import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import socket from "../../socket";
import { addNotification } from "../../Redux/actions/commonActtion";
import { getProjectDetails } from "../../Redux/actions/projectActions";
import CustomToast, { customToatStyle } from "../CustomToast/CustomToast";
import "../CustomToast/CustomToast.css";

export const RENDER_TOAST_CONTAINER_ID = "render-complete";

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
};

export default function RenderCompleteListener() {
  const dispatch = useDispatch();
  const currentProjectId = useSelector((state) => state?.project?._id);
  const isCard = useSelector((state) => state?.project?.isCard);
  const seenRenderIdsRef = useRef(new Set());
  const projectRef = useRef({ currentProjectId, isCard });
  projectRef.current = { currentProjectId, isCard };

  useEffect(() => {
    const handleRenderUpdate = (data) => {
      if (!data?.isRederFinished) return;

      const renderId = data?.renderId;
      if (renderId) {
        if (seenRenderIdsRef.current.has(renderId)) return;
        seenRenderIdsRef.current.add(renderId);
      }

      const message = `Render got completed for project ${data?.title || ""}.`;
      dispatch(addNotification(message));
      toast(
        <CustomToast title="" content={message} />,
        { ...customToatStyle, containerId: RENDER_TOAST_CONTAINER_ID },
      );

      const { currentProjectId: openId, isCard: openIsCard } =
        projectRef.current;
      if (openId && data?.projectId && String(openId) === String(data.projectId)) {
        dispatch(getProjectDetails(openId, openIsCard));
      }
    };

    const connectForUser = () => {
      const user = getStoredUser();
      if (!user?._id) {
        if (socket.connected) socket.disconnect();
        return;
      }
      if (!socket.connected) socket.connect();
      socket.emit("join-user-room", { userId: user._id });
    };

    socket.on("render-update", handleRenderUpdate);
    connectForUser();

    window.addEventListener("storage", connectForUser);
    window.addEventListener("focus", connectForUser);

    return () => {
      socket.off("render-update", handleRenderUpdate);
      window.removeEventListener("storage", connectForUser);
      window.removeEventListener("focus", connectForUser);
    };
  }, [dispatch]);

  const CloseButton = ({ closeToast }) => (
    <i
      className="material-icons w-7 flex justify-center cursor-pointer not-italic"
      onClick={closeToast}
    >
      ✖
    </i>
  );

  return (
    <ToastContainer
      enableMultiContainer
      containerId={RENDER_TOAST_CONTAINER_ID}
      closeButton={CloseButton}
      newestOnTop
    />
  );
}
